import { Button } from "web/components"

export default function SelectReferencesButton({ baseURL }) {
  return (
    <Button onClick={() => window.Turbo.visit(`${baseURL}/references`)}>
      Select References
    </Button>
  )
}
